module.exports = __webpack_public_path__ + "img/ksfe2.786118f2.jpeg";